// Vision-color palette. This is a mirror of domain.VisionColorPalette in
// internal/domain/blocks.go — the Go definition is CANONICAL: the server
// validates writes against it and a Go test pins the exact list. Keep the two in
// sync (cross-language duplication is accepted here to avoid shipping the palette
// over the wire on every load).
export interface VisionColorOption {
  id: string;
  hex: string;
  label: string;
}

export const VISION_COLOR_PALETTE: VisionColorOption[] = [
  { id: "coral", hex: "#E8664D", label: "Coral" },
  { id: "ember", hex: "#E8763C", label: "Ember" },
  { id: "amber", hex: "#E8A23C", label: "Amber" },
  { id: "gold", hex: "#E8C63C", label: "Gold" },
  { id: "citron", hex: "#B7C24A", label: "Citron" },
  { id: "lime", hex: "#86C33F", label: "Lime" },
  { id: "fern", hex: "#4CAE6A", label: "Fern" },
  { id: "emerald", hex: "#22B07C", label: "Emerald" },
  { id: "teal", hex: "#25A79A", label: "Teal" },
  { id: "cyan", hex: "#2CB4C6", label: "Cyan" },
  { id: "azure", hex: "#3E8FD6", label: "Azure" },
  { id: "indigo", hex: "#5A6BD8", label: "Indigo" },
  { id: "violet", hex: "#8A63D8", label: "Violet" },
  { id: "magenta", hex: "#B94FD1", label: "Magenta" },
  { id: "rose", hex: "#D857A0", label: "Rose" },
  { id: "salmon", hex: "#E8697C", label: "Salmon" }
];
